module.exports = __webpack_public_path__ + "static/media/4.30ef9561.jpg";